/* eslint-disable no-unused-vars */
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const baseAPIURL = process.env.VUE_APP_APIURL;

export default new Vuex.Store({
  state: {
    token: null,
    user: null,    
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token;
      axios.defaults.headers.common['Authorization'] = `Bearer ${decodeURIComponent(token)}`;
    },
    SET_USER(state, user) {
      state.user = user;
    }
  },
  actions: {
    userSubcriptionkeyGet({ commit, state }) {
      return axios.get(`${baseAPIURL}/security/user/subcription/keys/get`);
    },
    userGet({ commit, state }) {
      return axios.get(`${baseAPIURL}/security/user/get`);
    },
    userUpdate({ commit, state }, user) {
      return axios.post(`${baseAPIURL}/security/user/update`, user);
    },
    reportOperationsGet({ commit, state }, reportOperation) {
      return axios.post(`${baseAPIURL}/security/report/operations/get`, reportOperation);
    },
    customerGet({ commit, state }) {
      return axios.get(`${baseAPIURL}/security/customer/get`);
    },
    customerAttachCard({ commit, state }, customer) {
      return axios.post(`${baseAPIURL}/security/customer/attach/card`, customer);
    }    
  },
  modules: {
  }
})
